// src/palettes/basicPalettes.js
const basicPalettes = [
  { name: 'Light Grey', colors: ['#E5E5E5', '#F5F5F5', '#FAFAFA', '#FFFFFF', '#D4D4D4'] },
  { name: 'Deep Black', colors: ['#1a1a1a', '#333333', '#4d4d4d', '#666666', '#000000'] },
  { name: 'Pure White', colors: ['#FFFFFF', '#FAFAFA', '#F5F5F5', '#EFEFEF', '#E8E8E8'] },
  { name: 'Classic Navy', colors: ['#003366', '#004080', '#0059b3', '#0073e6', '#001a33'] },
  { name: 'Carbon', colors: ['#232B2B', '#363F3F', '#4B5555', '#5F6B6B', '#121616'] },
  { name: 'Slate', colors: ['#708090', '#8693A3', '#9CA6B6', '#B3BCC9', '#566A80'] },
  { name: 'Vibrant Primary', colors: ['#FF0000', '#0000FF', '#00FF00', '#FFFF00', '#FF00FF'] },
  { name: 'Pastel Basic', colors: ['#FFC0CB', '#ADD8E6', '#98FB98', '#FFFFE0', '#E6E6FA'] },
  { name: 'Neutral Tones', colors: ['#D3D3D3', '#C0C0C0', '#A9A9A9', '#808080', '#696969'] },
  { name: 'Lush Green', colors: ['#A8D5BA', '#7FC4A9', '#54B2A1', '#2BAF9B', '#009E93'] },
  { name: 'Fiery Red', colors: ['#FF6F61', '#FF4C3B', '#FF3A2E', '#FF2621', '#FF130F'] },
  { name: 'Sunny Yellow', colors: ['#FFF176', '#FFEE58', '#FFEB3B', '#FDD835', '#FBC02D'] },
  { name: 'Ocean Blue', colors: ['#80DEEA', '#4DD0E1', '#26C6DA', '#00BCD4', '#0097A7'] },
  { name: 'Royal Purple', colors: ['#B39DDB', '#9575CD', '#7E57C2', '#673AB7', '#512DA8'] },
  { name: 'Earth Brown', colors: ['#A1887F', '#8D6E63', '#795548', '#6D4C41', '#5D4037'] },
  { name: 'Vivid Orange', colors: ['#FFAB40', '#FF9100', '#FF6D00', '#FF5722', '#E64A19'] },
  // Additional palettes to double the amount:
  { name: 'Vibrant Pink', colors: ['#FF69B4', '#FF85C1', '#FF9ACD', '#FFAEB9', '#FFC0CB'] },
  { name: 'Citrus Burst', colors: ['#FFA000', '#FFCA28', '#FFD54F', '#FFE082', '#FFF8E1'] },
  { name: 'Minty Fresh', colors: ['#AAF0D1', '#98FF98', '#90EE90', '#77DD77', '#66FF66'] },
  { name: 'Deep Burgundy', colors: ['#800020', '#8B0000', '#A52A2A', '#B22222', '#C41E3A'] },
  { name: 'Electric Blue', colors: ['#0000FF', '#1E90FF', '#4169E1', '#6495ED', '#87CEFA'] },
  { name: 'Lavender Dreams', colors: ['#E6E6FA', '#D8BFD8', '#DDA0DD', '#EE82EE', '#DA70D6'] },
  { name: 'Rustic Copper', colors: ['#B87333', '#C17E3A', '#D2691E', '#CD7F32', '#8B4000'] },
  { name: 'Sunset Glow', colors: ['#FF7F50', '#FF6347', '#FF4500', '#FF8C00', '#FFA07A'] },
  { name: 'Forest Canopy', colors: ['#228B22', '#2E8B57', '#3CB371', '#66CDAA', '#8FBC8F'] },
  { name: 'Coral Reef', colors: ['#FF7F50', '#FF6347', '#FF7256', '#FF8264', '#FF9372'] },
  { name: 'Indigo Night', colors: ['#4B0082', '#483D8B', '#6A5ACD', '#7B68EE', '#9370DB'] },
  { name: 'Sky Blue', colors: ['#87CEEB', '#87CEFA', '#00BFFF', '#1E90FF', '#6495ED'] },
  { name: 'Olive Grove', colors: ['#808000', '#6B8E23', '#556B2F', '#8F9779', '#BDB76B'] },
  { name: 'Hot Magenta', colors: ['#FF00FF', '#FF33FF', '#FF66FF', '#FF99FF', '#FFCCFF'] },
  { name: 'Turquoise Tide', colors: ['#40E0D0', '#48D1CC', '#00CED1', '#20B2AA', '#5F9EA0'] },
  { name: 'Mossy Meadow', colors: ['#8A9A5B', '#7C8B4A', '#6F7D39', '#627127', '#556316'] },
];

export default basicPalettes;
